<template>
  <div class="organ-wrap">
    <div v-if="item.name" v-for="(item, index) in organList" :key="index" class="special">
      <div class="risk_top">
        <div>
          <img
            v-if="reportType === 'brain'"
            :src="ossUrl + '/brain/' + item.title + '.png'"
          />
          <img
            v-else-if="reportType === 'thyroid'"
            :src="ossUrl + '/'+reportType+'/' + (index+1) + '.png'"
          />
          <img
            v-else
            :src="ossUrl + '/diseasa/' + item.title + '.png'"
          />
          {{ item.name }}
        </div>
        <div class="statuslist">
          <div
            v-for="child in ristStatus"
            :key="child.id"
            :class="child.id == item.level ? 'active ristStatus' : 'ristStatus'"
          >
            {{ child.name }}
          </div>
        </div>
      </div>
      <div v-if="item.showCon && reportType != 'thyroid'" class="risk_cont">
        <div v-if="item.exam_desc" class="red_title">常见健康风险</div>
        <div class="span" v-html="item.exam_desc"></div>
        <div v-if="item.exam_references" class="red_title">健康管理建议</div>
        <div class="span" v-html="item.exam_references"></div>
        <div v-if="item.experts_science" class="red_title">专家建议</div>
        <div class="span" v-html="item.experts_science"></div>
      </div>
      <div v-if="item.showCon && reportType == 'thyroid'" class="risk_cont_thyroid">
        <div class="cont-title">
          <div class="red_title">名词解释</div>
          <div class="btns" @click="toDetails(index)">
            <img :src="ossUrl + '/thyroid/details.png'" />
            详情
          </div>
        </div>
        <span>{{ item.desc }}</span>
      </div>
      <div
        v-if="
          item.exam_desc ||
          item.exam_references ||
          item.experts_science ||
          item.desc
        "
        class="risk_btn"
        @click="handleContent(item)"
      >
        {{ item.btntxt }}
        <img
          :class="item.showCon ? 'rotates' : ''"
          :src="ossUrl + '/down.png'"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { ossUrl } from "@/config";
export default {
  name: "",
  props: {
    organList: {
      type: Array,
      default() {
        return [];
      },
    },
    reportType: {
      type: String,
      default: "normal",
    },
    datas: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      ossUrl,
      ristStatus: [
        { name: "低", id: 1 },
        { name: "偏低", id: 2 },
        { name: "中", id: 3 },
        { name: "偏高", id: 4 },
        { name: "高", id: 5 },
      ], // 风险等级
    };
  },
  methods: {
    handleContent(item) {
      console.log("asdf", item);

      if (item.showCon) {
        item.btntxt = "查看建议";
      } else {
        item.btntxt = "收起";
      }
      item.showCon = !item.showCon;
    },
    toDetails(index) {
      let thyroidData = {};
      switch (index) {
        case 0:
          thyroidData = this.datas.thyroid_nodule
          break;
        case 1:
          thyroidData = this.datas.goiter_simple
          break;
        case 2:
          thyroidData = this.datas.subacute_thyroiditis
          break;
        case 3:
          thyroidData = this.datas.hyperthyreosis
          break;
        case 4:
          thyroidData = this.datas.hypothyroidism
          break;
        case 5:
          thyroidData = this.datas.thyroid_cyst
          break;
        case 6:
          thyroidData = this.datas.thyroid_tumor
          break;
      }
      this.$store.dispatch('updateThyroidDataAct', thyroidData)
      this.$router.push('/thyroidDetail')
    },
  },
};
</script>
<style lang="scss" scoped>
.organ-wrap {
  width: 700px;
  margin: 40px auto 20px;
}
.special {
  background-color: #fff;
  padding: 0 25px;
  margin: 0 auto 20px;
}
.risk_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;
  padding: 30px 0;
  font-size: 34px;
}
.risk_top > div:first-child {
  display: flex;
  align-items: center;
  font-size: 30px;
}
.risk_top img {
  width: 42px;
  height: 42px;
  vertical-align: middle;
  margin-right: 16px;
}
.statuslist {
  display: flex;
}
.statuslist .ristStatus {
  width: 68px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  background-color: #b5b5b5;
  border-left: 1px solid #fff;
  font-size: 24px;
  text-align: center;
}
.statuslist .active {
  position: relative;
}
.statuslist .active::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  bottom: -20px;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom-width: 20px;
  border-bottom-style: solid;
}
.ristStatus:nth-child(1) {
  background-color: #009944;
}
.ristStatus:nth-child(1).active::before {
  border-bottom-color: #009944;
}
.ristStatus:nth-child(2) {
  background-color: #a2e317;
}
.ristStatus:nth-child(2).active::before {
  border-bottom-color: #a2e317;
}
.ristStatus:nth-child(3) {
  background-color: #f29238;
}
.ristStatus:nth-child(3).active::before {
  border-bottom-color: #f29238;
}
.ristStatus:nth-child(4) {
  background-color: #dd352a;
}
.ristStatus:nth-child(4).active::before {
  border-bottom-color: #dd352a;
}
.ristStatus:nth-child(5) {
  background-color: #a01d18;
}
.ristStatus:nth-child(5).active::before {
  border-bottom-color: #a01d18;
}
.risk_cont {
  font-size: 28px;
  color: #616161;
  padding: 25px 0;
  border-bottom: 1px solid #ddd;
  text-align: left;
}
.red_title {
  font-size: 28px;
  color: #d30909;
  margin: 25px 0 5px;
  font-weight: bold;
}
.risk_btn {
  font-size: 24px;
  color: #949494;
  padding: 25px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.risk_btn img {
  width: 21px;
  height: 11px;
  margin-left: 5px;
}
.risk_btn img.rotates {
  transform: rotate(180deg);
}
.nodata {
  position: relative;
  width: 640px;
  margin: auto;
  text-align: left;
  padding: 60px 0;
  line-height: 50px;
}
.nodata p {
  margin-bottom: 20px;
  margin-top: 0;
}
.risk_cont_thyroid{
  font-size: 28px;
  color: #616161;
  padding: 25px 0;
  border-bottom: 1px solid #ddd;
  text-align: left;
  .cont-title{
    display: flex;
    justify-content: space-between;
    .btns{
      background-color: #fff;
      color: #2E94E5;
      display: flex;
      align-items: center;
      height: 42px;
      font-weight: bold;
       img{
        width: 32px;
        height: 32px;
        margin-right: 6px;
      }
    }
    .red_title{
      font-size: 28px;
      color: #D30909;
      margin: 15px 0;
      font-weight: bold;
    }
    .risk_btn{
      font-size: 24px;
      color: #949494;
      padding: 25px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      img{
        width: 21px;
        height: 11px;
        margin-left: 5px;
        .rotates{
          transform: rotate(180deg);
        }
      }
    }
  }
}
</style>